module.exports = __webpack_public_path__ + "img/empty-reverse-scan.e61d9808.svg";